<template>
  <v-container fluid>
    <v-dialog width="800" v-model="show" scrollable>
    <v-card max-width="800" max-height="800">
      <v-card-title>
        <span>[HD현대에너지솔루션] {{detailData.bill_date_text}} 통신비 명세서</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-divider></v-divider>
        <v-row class="table-header-bg mx-0">
          <v-col class="font-weight-bold">HD현대에너지솔루션 명세서</v-col>
          <v-divider vertical></v-divider>
          <v-col class="text-center">{{detailData.bill_date_text}}</v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mx-0">
          <v-col class="font-weight-bold">고객명</v-col>
          <v-divider vertical></v-divider>
          <v-col class="text-center">{{detailData.user_nm}}</v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mx-0">
          <v-col class="font-weight-bold">이용금액(자동이체)</v-col>
          <v-divider vertical></v-divider>
          <v-col class="text-center">{{detailData.amount_text}}원</v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mx-0">
          <v-col class="font-weight-bold">이용기간</v-col>
          <v-divider vertical></v-divider>
          <v-col class="text-center">{{detailData.start_date_text}} ~ {{detailData.end_date_text}}</v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="table-header-bg mx-0">
          <v-col class="font-weight-bold">고객정보 사항</v-col>
          <v-divider vertical></v-divider>
          <v-col class="text-center">{{detailData.bill_date_text}}</v-col>
        </v-row>
        <v-divider></v-divider>
        <div v-for="(billDetailInfo, index) in billDetailInfo"
             :key="'bill_'+index">
          <v-row class="mx-0">
            <v-col class="font-weight-bold">사이트</v-col>
            <v-divider vertical></v-divider>
            <v-col class="text-center">{{detailData.site_nm}}</v-col>
          </v-row>
          <v-divider></v-divider>
          <div v-for="billDetail in billDetailInfo.billDetail"
               :key="billDetail.sortorder">
            <v-row class="mx-0">
              <v-col class="font-weight-bold">{{billDetail.item}} ({{billDetail.qty}}EA)</v-col>
              <v-divider vertical></v-divider>
              <v-col class="text-center">{{billDetail.price_text}}원</v-col>
            </v-row>
            <v-divider></v-divider>
          </div>
          <v-row class="mx-0">
            <v-col class="font-weight-bold">인버터 용량</v-col>
            <v-divider vertical></v-divider>
            <v-col class="text-center">{{billDetailInfo.inv_capa_text}}kW</v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="mx-0">
            <v-col class="font-weight-bold">인버터 대수</v-col>
            <v-divider vertical></v-divider>
            <v-col class="text-center">{{billDetailInfo.inv_qty_text}}EA</v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="mx-0">
            <v-col class="font-weight-bold">당월 인버터누적 발전량</v-col>
            <v-divider vertical></v-divider>
            <v-col class="text-center">{{billDetailInfo.month_power_text}}kWh</v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="mx-0">
            <v-col class="font-weight-bold">전월 인버터누적 발전량</v-col>
            <v-divider vertical></v-divider>
            <v-col class="text-center">{{billDetailInfo.pre_month_power_text}}kWh</v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="mx-0">
            <v-col class="font-weight-bold">총 인버터누적 발전량</v-col>
            <v-divider vertical></v-divider>
            <v-col class="text-center">{{billDetailInfo.tot_power_text}}kWh</v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="mx-0">
            <v-col class="font-weight-bold">총 인버터누적 발전시간</v-col>
            <v-divider vertical></v-divider>
            <v-col class="text-center">{{billDetailInfo.tot_power_hour_text}}h</v-col>
          </v-row>
          <v-divider></v-divider>
        </div>
      </v-card-text>
    </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { getBillDetailInfo } from '@/api/greenCommon/common'

export default {
  name: 'BillDetail',
  props: {
    detailData: { type: Object, default: null },
    showEvent: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showEvent(newValue) {
      this.show = true
      this.init_data()
    }
  },
  data() {
    return {
      show: false,
      component_key: 0,
      component_show: false,
      billDetailInfo: {}
    }
  },
  mounted() {
    // this.init_data()
  },
  methods: {
    init_data() {
      if (this.detailData) {
        let params = {
          user_id: this.detailData.user_id,
          bill_date: this.detailData.bill_date
        }

        getBillDetailInfo(params).then(response => {
          this.billDetailInfo = response.billDetailInfo
        })
      }
    },
    closeLayer() {
      this.$emit('update:component_show', false)
    }
  },
  created() {}
}
</script>

<style lang='less' scoped>
.table-header-bg {
  background-color: var(--v-hth-base);
}

.card-header-bg {
  background-color: var(--v-hth-base);
}
</style>
